import { WidgetLuccaAbsenceUser } from 'jamespot-user-api';
import React from 'react';

import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { JRCTypography } from '../../JRCTypography/JRCTypography';
import { JRCWidgetLuccaAbsenceStatus } from './JRCWidgetLuccaAbsenceStatus';
import { JRCAvatar } from 'components/JRCAvatar/JRCAvatar';

export const UIList = styled.ul`
    list-style: none;
`;

export const UIListItem = styled.li`
    display: flex;
    flex-direction: row;
    gap: ${(props) => props.theme.space.md}px;
    padding: ${(props) => props.theme.space.md}px;
`;

export const UIListItemAvatar = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 40px;
`;

export const UIListItemNoAvatar = styled.div<{ bgColor: string }>`
    width: 40px;
    height: 40px;
    border-radius: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.color.white};
    background-color: ${(props) => props.bgColor};
`;

export const UIListItemData = styled.div`
    display: flex;
    flex-direction: column;
`;

export const JRCWidgetLuccaAbsence = ({ list }: { list: WidgetLuccaAbsenceUser[] }) => {
    if (list.length === 0) return <FormattedMessage id={'WIDGET_Lucca_Absence_No_Result'} />;
    return (
        <UIList>
            {list.map((user) => {
                return (
                    <UIListItem key={`${user.uri}`}>
                        <UIListItemNoAvatar bgColor={'#' + ((Math.random() * 0xffffff) << 0).toString(16)}>
                            <JRCAvatar size={5} uri={user.uri} />
                        </UIListItemNoAvatar>
                        <UIListItemData>
                            <JRCTypography size={'m'} weight={'bold'}>
                                {user.title}
                            </JRCTypography>
                            <JRCWidgetLuccaAbsenceStatus datetime={user.absentUntil} />
                        </UIListItemData>
                    </UIListItem>
                );
            })}
        </UIList>
    );
};
